import {checkPerm, getProp, longTableColumn, resourceIsUpdated} from "../../../util/util-helpers";
import Resources from "../../../../data/services/resources";
import {
    COUNTRY_ID_USA,
    DEFAULT_DATABASE_DATE_FORMAT,
    DEFAULT_DATABASE_DATETIME_FORMAT,
    STOP_TYPE_PICKUP,
    STOP_TYPE_PICKUP_AND_DELIVERY,
    UPDATE_PERM
} from "../../../util/util-consts";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import PencilSquareIcon from "@heroicons/react/20/solid/PencilSquareIcon";
import Button from "../../button";
import React, {useEffect, useRef, useState} from "react";
import {getThirdResource, resetThirdResource, updateThirdResource} from "../../../../data/actions/thirdResource";
import ResourceList from "../../layout/layout-components/resource-list";
import CheckIcon from "@heroicons/react/20/solid/CheckIcon";
import PlusCircleIcon from "@heroicons/react/24/outline/PlusCircleIcon";
import ModalDefault from "../modal-default";
import {useDispatch, useSelector} from "react-redux";
import {Field, FieldsManager} from "../../../../data/services/fields";
import LocalStorage from "../../../util/localStorage";
import ModalConfirm from "../modal-confirm";
import moment from "moment-timezone";
import NavResponsive from "../../nav-responsive";
import MobileTabs from "../../tabs-navigation/mobile-tabs";
import Card from "../../card";
import {fieldsToHtml} from "../../../util/util-fields";
import {LoaderLarge} from "../../loader";

export default function RecalculateLoadMileage({
    stopsCombined, fetchLoadData, isLoading, LoadID, translate, isLoadDelivered,
    // Optional external-control props (used when opened from outside, e.g. LocationsTab):
    truckID,                      // overrides TruckID from Redux resource
    isOpen: externalIsOpen,       // controls modal visibility externally
    onDialogClose,                // called when dialog closes in external mode
    initialSelectedTruckLocationID, // auto-select this location when thirdResource list loads
}) {
    const dispatch = useDispatch();
    const resource = useSelector(state => state.resource);
    const thirdResource = useSelector(state => state.thirdResource);

    const isExternallyControlled = externalIsOpen !== undefined;
    const OriginalTruckID = truckID ?? getProp(resource, "data.load/info.TruckID", undefined);
    const [isManualMileageRecalculationModalOpen, setIsManualMileageRecalculationModalOpen] = useState(false);
    const [selectedPrevLocation, setSelectedPrevLocation] = useState(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const data = getProp(thirdResource.data, 'list', []);
    const count = getProp(thirdResource.data, 'count', 0);
    const thirdResourceIsLoading = getProp(thirdResource, 'isLoading', false)

    const [queryFields, setQueryFields] = useState(getQueryFields(translate));
    const query = Object.assign({}, FieldsManager.getFieldKeyValues(queryFields), {id: OriginalTruckID});
    const inputRef = useRef(null);
    const [manualFields, setManualFields] = useState(getManualFields())
    const [canSubmit, setCanSubmit] = useState(false)

    const getTruckLocationsPath = () => Resources.TrucksLocations

    function getTabs() {
        return [
            {
                id: 1,
                name: 'Create',
                resource: 'create',
                visible: true,
                invalid: false,
                current: true
            },
            {
                id: 2,
                name: 'Select',
                resource: 'select',
                visible: true,
                invalid: false,
                current: false
            }
        ];
    }

    const [tabs, setTabs] = useState(getTabs());
    const currentTab = tabs.find(it => it.current);
    const handleTabChange = (tabName) => {
        let tabsUpdate = [...tabs];
        tabsUpdate.map(tab => {
            tab.current = tabName === tab.resource;

            return tab;
        });

        setTabs(tabsUpdate);
        setManualFields(getManualFields());
    }

    const reCalculate = () => {
        let params = {};
        if (currentTab.name === 'Create') {
            params.CityName = manualFields.CityName.value;
            params.StateID = manualFields.StateID.value;
            params.PostalCode = manualFields.PostalCode.value;
            params.AddressName = manualFields?.AddressName?.value;
            params.LocationDate = manualFields?.LocationDate?.value;
            params.CountryID = manualFields?.CountryID?.value;
            params.isMoving = 0;
            params.LoadID = Number(LoadID)
        } else if (currentTab.name === 'Select') {
            params.LoadID = Number(LoadID);
            params.TruckLocationID = selectedPrevLocation?.TruckLocationID
        }

        dispatch(updateThirdResource({
            user: LocalStorage.get('user'),
            params: params,
            resource: Resources.LoadPostMileage,
            errorMessage: true, successMessage: `Mileage re-calculated`,
        }))
    }


    function getPrevTruckFields() {
        return {
            LocationName: new Field("LocationName", '', [], false, 'text', {
                omitSort: true,
                render: (item) => {
                    return (<div className={"flex"}>{selectedPrevLocation?.TruckLocationID === item.TruckLocationID ?
                        <CheckIcon className="w-5 h-5 text-green-500"/> : null}{item.LocationName}</div>)
                }
            }),
            LocationDate: new Field("LocationDate", '', [], false, 'datetime', {
                columnName: "Date",
                omitSort: true
            }),
            AddressName: new Field("AddressName", '', [], false, 'text', {omitSort: true}),
            CityName: new Field("CityName", '', [], false, 'text', {omitSort: true}),
            State: new Field("State", '', [], false, 'text', {omitSort: true}),
            CountryName: new Field("CountryName", '', [], false, 'text', {omitSort: true}),
            Source: new Field("Source", '', [], false, 'text', {omitSort: true}),
            LoadNumber: new Field('LoadNumber', '', [], false, 'custom', {omitSort: true}),
            Notes: new Field('Notes', '', [], false, 'text', {
                render: (item) => (
                    <>{longTableColumn(item.Notes)}</>
                ),
                omitSort: true
            })
        }
    }

    function handleSetLocations(fields) {
        setManualFields(prevFields => {
            let updatedFields = Object.assign({}, prevFields);

            for (const [key, value] of Object.entries(fields)) {
                if (key in prevFields) {
                    updatedFields = FieldsManager.updateField(updatedFields, key, value);
                }
            }

            updatedFields = FieldsManager.updateField(updatedFields, 'LocationDate', prevFields['LocationDate'].value);
            setCanSubmit(true);
            return updatedFields;
        });
    }

    function getManualFields() {
        const pickupMoment = moment(stopsCombined[0].metadata.StopDate + " " + stopsCombined[0].metadata.StopTime);
        const defaultMoment = pickupMoment.clone().subtract(15, 'minutes');
        return {
            LocationDate: new Field('LocationDate', defaultMoment.format(DEFAULT_DATABASE_DATETIME_FORMAT), ['empty'], false, 'date', {addContainerClass: 'col-span-4'}, {maxDate: pickupMoment.format(DEFAULT_DATABASE_DATETIME_FORMAT)}),
            LocationTime: new Field('LocationTime', defaultMoment.format('HH:mm'), [], false, 'time-custom-new', {
                addContainerClass: 'col-span-3',
                withDateField: 'LocationDate'
            }),
            GooglePlaces: new Field('GooglePlaces', '', [''], false, "google-locations", {
                setLocations: handleSetLocations,
                addContainerClass: "col-span-8",
                label: "location_autocomplete"
            }, {innerRef: inputRef}),
            CountryID: new Field('CountryID', COUNTRY_ID_USA, ['empty'], false, 'select', {addContainerClass: 'col-span-4'}),
            AddressName: new Field('AddressName', '', [''], false, 'text', {addContainerClass: 'col-span-full'}),
            CityName: new Field('CityName', '', ['empty'], false, 'text', {addContainerClass: 'col-span-4'}),
            StateID: new Field('StateID', '', ['empty'], false, 'select', {addContainerClass: 'col-span-4'}, {hasPortal: true}),
            PostalCode: new Field('PostalCode', '', ['empty'], false, 'text', {addContainerClass: 'col-span-4'}),
        }
    }

    const handleToggleConfirmModal = () => {
        setConfirmModalOpen(!confirmModalOpen);
    }

    const fetchPrevTruckLocationData = () => {
        dispatch(getThirdResource({
            user: LocalStorage.get("user"),
            resource: getTruckLocationsPath(),
            query: query
        }));
    }


    function getQueryFields(translate) {
        let endLocationDate = stopsCombined.find(it => it?.metadata?.StopType === STOP_TYPE_PICKUP || it?.metadata?.StopType === STOP_TYPE_PICKUP_AND_DELIVERY)?.metadata?.StopDate;
        if (endLocationDate) {
            endLocationDate = moment(endLocationDate, DEFAULT_DATABASE_DATE_FORMAT).add(1, "day").format(DEFAULT_DATABASE_DATETIME_FORMAT);
        }

        return {
            EndLocationDate: new Field('EndLocationDate', endLocationDate, [''], false, 'date', {addContainerClass: "col-span-1"}),
            sort: new Field('sort', 'DESC', [''], false, 'hidden'),
            sortBy: new Field('sortBy', "LocationDate", [''], false, 'hidden'),
            offset: new Field('offset', "0", [''], false, 'hidden'),
            limit: new Field('limit', "20", [''], false, 'select', {
                hideLabel: true,
                labelType: "float"
            }, {
                placeholder: "100",
                menuPlacement: "top"
            })
        };
    }

    useEffect(() => {
        setQueryFields(getQueryFields(translate));
    }, [stopsCombined])

    useEffect(() => {
        const open = isExternallyControlled ? externalIsOpen : isManualMileageRecalculationModalOpen;
        if (!!open && !isLoading) {
            fetchPrevTruckLocationData();
        }
    }, [queryFields]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (resourceIsUpdated(thirdResource)) {
            fetchLoadData();
            dispatch(resetThirdResource());
            if (isExternallyControlled) {
                onDialogClose?.();
            } else {
                setIsManualMileageRecalculationModalOpen(false);
            }
        }
    }, [thirdResource]);

    // When opened externally, initialise state and fetch locations.
    useEffect(() => {
        if (isExternallyControlled && externalIsOpen) {
            setSelectedPrevLocation(null);
            setTabs(getTabs());
            setManualFields(getManualFields());
            setCanSubmit(false);
            fetchPrevTruckLocationData();
        }
    }, [externalIsOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    // Auto-select the suggested location once the list has loaded.
    // Uses ID comparison so stale Redux data from a previous open cannot block re-selection.
    useEffect(() => {
        if (!initialSelectedTruckLocationID || data.length === 0) return;
        if (selectedPrevLocation?.TruckLocationID === initialSelectedTruckLocationID) return;
        const match = data.find(d => d.TruckLocationID === initialSelectedTruckLocationID);
        if (match) setSelectedPrevLocation(match);
    }, [data, initialSelectedTruckLocationID]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (inputRef.current) {
            const timer = setTimeout(() => {
                inputRef.current.focus();
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [currentTab]);

    useEffect(() => {
        setManualFields(getManualFields());
        setTabs(getTabs());
    }, [isManualMileageRecalculationModalOpen]);

    function handleInputChange(name, value) {
           setManualFields(FieldsManager.updateField(manualFields, name, value));
           setCanSubmit(true);
    }

    const fieldsManuallyHtml = fieldsToHtml(Object.values(Object.assign({}, manualFields)), translate, (name, value) => handleInputChange(name, value), {})

    const isModalOpen = isExternallyControlled ? externalIsOpen : isManualMileageRecalculationModalOpen;

    const handleClose = () => {
        if (!thirdResourceIsLoading) {
            if (isExternallyControlled) {
                onDialogClose?.();
            } else {
                setIsManualMileageRecalculationModalOpen(false);
                setSelectedPrevLocation(null);
                setManualFields(getManualFields());
                setTabs(getTabs());
                setCanSubmit(false);
            }
        }
    };

    return <>
        {!isExternallyControlled && (
            <Button
                hasPerm={checkPerm(Resources.LoadPostMileage, UPDATE_PERM)}
                className={isLoadDelivered ? undefined : "btn-outline btn"}
                appearance={isLoadDelivered ? "warning" : undefined}
                disabled={false}
                onClick={() => {
                    setIsManualMileageRecalculationModalOpen(true);
                    setSelectedPrevLocation(null);
                    fetchPrevTruckLocationData();
                }}
                toolTip={
                    isLoadDelivered
                        ? "Override action - load is delivered. Requires elevated permission."
                        : translate("text.recalculate_mileage_tooltip_enabled")
                }
            >
                {isLoadDelivered
                    ? <PencilSquareIcon className="w-4 h-4 mr-2"/>
                    : <ArrowPathIcon className="w-5 h-5 mr-2"/>}
                {isLoadDelivered ? "Amend empty mileage" : translate("btn.recalculate")}
            </Button>
        )}

        <ModalDefault
            show={isModalOpen}
            title="Amend empty mileage"
            widthClass={"max-w-7xl"}
            limitHeight={true}
            translate={translate}
            onClose={handleClose}
            closeButtonLabel={translate('btn.close')}
            closeButtonDisabled={thirdResourceIsLoading}
            buttonLabel={"Re-calculate"}
            onButtonClick={() => {
                if (currentTab.name === 'Create') {
                    let validatedFields = FieldsManager.validateFields(manualFields)
                    if (FieldsManager.checkFieldsForErrors(validatedFields)) {
                        handleToggleConfirmModal();
                    } else {
                        setManualFields(validatedFields)
                    }
                } else handleToggleConfirmModal();
            }}
            buttonDisabled={currentTab.name === 'Create' ? (!canSubmit) : thirdResourceIsLoading}
        >
                {thirdResourceIsLoading && (<div><LoaderLarge stripesBg/></div>)}

                <div className="hidden sm:block relative z-0">
                    <NavResponsive
                        tabs={tabs}
                        onTabChange={handleTabChange}
                        translate={translate}
                    />
                </div>

                <div className="mb-5">
                    <MobileTabs
                        tabs={tabs}
                        onTabChange={handleTabChange}
                        translate={translate}
                    />
                </div>

                {currentTab.name === 'Select' &&
                    (<div className="mx-4 mb-4">
                        <ResourceList
                            tableCardClass="max-h-[100%-20rem] min-h-[24rem] md:overflow-hidden relative"
                            fields={getPrevTruckFields()}
                            Data={data}
                            Count={count}
                            isLoading={thirdResourceIsLoading}
                            queryFields={queryFields}
                            setQueryFields={setQueryFields}
                            listPath={'PrevTruckLocations'}
                            dispatch={dispatch}
                            query={{}}
                            onRefreshTable={fetchPrevTruckLocationData}
                            translate={translate}
                            actions={[
                                {
                                    icon: (item) => selectedPrevLocation?.TruckLocationID === item.TruckLocationID ? CheckIcon : PlusCircleIcon,
                                    title: translate("btn.select_location"),
                                    hasPerm: true,
                                    action: (item) => {
                                        setSelectedPrevLocation(item);
                                    }
                                }
                            ]}
                            tableKey={"TruckLocationID"}
                            tableDefaults={{
                                behaviour: {
                                    rowSelect: true,
                                    hasMenu: false,
                                    canAdjustWidth: true
                                },
                                style: {
                                    condensed: true,
                                    isGPUAccelerated: true
                                }
                            }}
                        />
                    </div>)
                }

                {currentTab.name === 'Create' && (
                    <Card addClass={'relative mt-5 mb-10'}>
                        <div className={'grid grid-cols-12 gap-5'}>
                            {fieldsManuallyHtml}
                        </div>
                    </Card>
                )}

                <ModalConfirm
                    title={"Confirm"}
                    type="warning"
                    show={!!confirmModalOpen}
                    textClassName={"break-word text-sm text-tm-gray-900"}
                    text={currentTab.name === 'Select' ? (selectedPrevLocation?.TruckLocationID ? translate("text_confirm_selected_recalculate_location") : translate("text_confirm_proceed_recalculate_no_location")) : translate("text_confirm_selected_recalculate_location")}
                    onClose={handleToggleConfirmModal}
                    buttonLabel={translate("btn.confirm")}
                    closeButtonLabel={translate('btn.cancel')}
                    translate={translate}
                    onConfirm={() => {
                        reCalculate();
                        handleToggleConfirmModal();
                        setSelectedPrevLocation(null);
                    }}
                />
        </ModalDefault>
</>
}
